import React, { useState } from 'react';
import './quick-reply-chips.scss';

interface QuickReplyChipsProps {
  options: Array<{ label: string; value: string }>;
  onSelect: (value: string) => void;
  disabled?: boolean;
}

export const QuickReplyChips: React.FC<QuickReplyChipsProps> = ({
  options,
  onSelect,
  disabled = false,
}) => {
  const [clicked, setClicked] = useState(false);

  const handleClick = (value: string) => {
    if (clicked || disabled) return;
    setClicked(true);
    onSelect(value);
    
    // Double-click protection: reset clicked state after short delay
    setTimeout(() => {
      setClicked(false);
    }, 1500);
  };

  return (
    <div className="v2-quick-reply-container">
      {options.map((option, idx) => (
        <button
          key={idx}
          className="v2-quick-reply-chip"
          onClick={() => handleClick(option.value)}
          disabled={clicked || disabled}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
